<template>
  <div v-show="show" :style="{ 'z-index': (currentZIndex-1)}">
    <div :style="{ 'z-index': (currentZIndex)}"
      class="dimmed_black" style="top:0;display:block;"></div>
    
    <div :style="{ 'z-index': (currentZIndex+1)}"
      class="rew19_popContainer big" style="display:block;">

      <div class="rew19_popup_wrap">
        <h2>
          <span class="rew19_basketList_tit">맴버쉽 바코드</span>
          <button class="rew19_basketList_btn" @click="onCancel"><span>닫기</span></button>
        </h2>
      </div>
      <div class="rew19_popup_flexwrap">
        <div class="rew19_barcode-container">
          <swiper :options="swiperOption" ref="mySwiper" @slideChange="slideChange">
            <!-- slides -->
            <swiper-slide 
              v-if="viewData.memberList.length > 0"
              v-for="(barcode) in viewData.memberList" :key="barcode.memberId">
              <vue-barcode 
                class="retina_img" 
                :key="barcode.memberId"
                :value="barcode.memberId" 
                :options="{ displayValue: false }" tag="img"></vue-barcode>
              <ul class="rew19_barcode-content">
                <li>{{barcode.memberId}}</li>
                <li>{{barcode.memberTypeName}}:{{barcode.memberName}}</li>
              </ul>
            </swiper-slide>

            <!-- Optional controls -->
            <div class="swiper-pagination"  slot="pagination"></div>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>            
          </swiper>                      
                 
        </div>
      </div><!--//rew19_popup_flexwrap-->      
      <div class="rew19_popup_btn">
        <button class="rew19_popFull activation" @click="onCancel">닫기</button>
      </div>
    </div>
  </div>  
</template>
<script>
import * as ErrMsg from "@/utils/error_msg";
import VueBarcode from '@xkeshi/vue-barcode';
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

const DEFAULT_VIEWDATA = {
  memberList : [],
  curBarcode:{}
};

export default {
  name: 'MemberShipBarcodeDialog',
  components: { VueBarcode, swiper, swiperSlide },
  props: {
    show: {
      type: Boolean,
      default: false
    } 
  },
  data() {
    return {
      currentZIndex : 2000,

      swiperOption: {
        slidesPerView: 1,
	      //loop: true,           
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },

      viewData : {...DEFAULT_VIEWDATA}      
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  },
  watch: {
    show(show) {
      this.$modalAfterTreat(show);

      show && this.$nextTick(() => {
        let _this = this;
        _this.currentZIndex = _this.$getDimmMaxIndex() + 2;

        this.$el.focus();
      })
    }
  },
  updated: function () {
    this.$nextTick(function () {
      $(".rew19_popContainer.big .rew19_popup_cont").css('height', $(window).height() - 102); 
    })
  },
  mounted() {
    let _this = this;

  },  
  methods :{
    onClose(response) {
      let _this = this;
      
      let resData = {};
      
      _this.$emit('close', response, response ? resData: null);      
    },
    onCancel(){
      this.onClose(false);
    },
    onOk() {
      this.onClose(true);
    },

    /**
     * API Request
     */    
    //회원정보 얻기
    apiGetMembers(){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/members`, {
        params: {}        
      });
    },

    /**
     * Local 
     */
    initData : function(paramData){
      let _this = this;

      _this.viewData = {
        ...DEFAULT_VIEWDATA,
        ...paramData,
      };

      //초기화 동시에 인증번호 요청
      _this.loadMembersInfo();
    },

    //회원정보 로드
    loadMembersInfo(){
      let _this = this;
      
      //회원정보 가져오기
      _this.$showLoading();      
      _this.apiGetMembers().then(res=>{
          
        if (res.status === 200 && res.data.status === "0000") {          
          _this.viewData = {
            ...DEFAULT_VIEWDATA,            
          };
          _this.viewData.memberList = [...res.data.memberList];

          _this.viewData.memberList.map(item=>{
            item.memberTypeName = item.memberType ? "대표자" : "공동자";
            return item;
          });          
          return;
        }
        let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
        _this.$dialogs.alert(errMsg)
        .then(res => {
          _this.onCancel();
        });        

      }).catch((err)=>{
        console.error(err);

        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        //hide loading
        _this.$hideLoading();
      });
    },

    onSetTranslate() {
      console.log('onSetTranslate')
    },

    slideChange(a,b,c,d){
    }
  }
}
</script>
<style>
.rew19_barcode-container .swiper-slide {
  text-align:center;
}
.rew19_barcode-content{
  margin-top: 5px;
  margin-bottom:30px;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/MemberShipBarcodeDialog.vue